import type { FlashcardsMediaClient } from './flashcards-media.client'

export function preparedMediaOptions(bucket: FlashcardsMediaClient, paths: readonly string[]) {
  const unique = [...new Set(paths)].toSorted()
  return {
    queryKey: ['prepared-media', bucket.sessionId, ...unique],
    queryFn: () => bucket.prepare(unique),
    subscribe: (invalidate: () => void) => Promise.resolve(bucket.subscribeMediaWrites(path => { if (unique.includes(path)) invalidate() })),
    staleTime: Infinity,
    retry: false,
  }
}
